

export interface CertificateDataIssue{
  address: string;
  id: number;
  issueBase: string;
  issueTime: string;
  issueType: string; 
}

export interface CertificateDataIssueResponse {
  dataIssues: CertificateDataIssue[];
}
